// extracted by mini-css-extract-plugin
export default {"panel":"styles__panel--YSLvg","close-button":"styles__close-button--AjAPA","content":"styles__content--CenTm","footer":"styles__footer--UGMT0"};